import { inject, Injectable } from '@angular/core';
import {
  IHotJobState,
  IMaintenanceQuote,
  IQuote,
  IQuoteDocumentsByCategory,
  IQuoteListView,
} from '../quotes/shared/interfaces';
import { Observable, of } from 'rxjs';
import { IQuoteItemPointsListConfiguration } from '../../reports/points-schedule/models';
import { ApiGatewayService } from '../../core/api-gateway.service';
import { HttpParams } from '@angular/common/http';

export interface UniqueRefResponse {
  reference_exists: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class QuoteDataGatewayService {
  private gateway: ApiGatewayService = inject(ApiGatewayService);

  constructor() {}

  loadquotes(collation?: string): Observable<IQuoteListView[]> {
    let url = '/quotes';
    if (collation) {
      url += `?${collation}`;
    }

    return this.gateway.get<IQuoteListView[]>(url);
  }

  storeQuote(quote: IQuote) {
    return this.gateway.post<IQuote, any>('/quotes', quote);
  }

  updateQuote(quote: IQuote) {
    return this.gateway.post<IQuote, any>('/quotes/edit', quote);
  }

  storeMaintenanceQuote(quote: IMaintenanceQuote) {
    return this.gateway.post<IMaintenanceQuote, any>(
      '/quotes/maintenance',
      quote,
    );
  }

  patchMaintenanceQuote(quote: IMaintenanceQuote) {
    return this.gateway.patch<IMaintenanceQuote, IMaintenanceQuote>(
      '/quotes/maintenance/' + quote.quote_id,
      quote,
    );
  }

  getQuote(quote_id: string): Observable<IQuote> {
    return this.gateway.get<IQuote>('/quotes/' + quote_id);
  }

  getMaintenanceQuote(id: string): Observable<IMaintenanceQuote> {
    return this.gateway.get<IMaintenanceQuote>('/quotes/maintenance/' + id);
  }

  //!FIXME: take this out of here!
  get quote_id(): string {
    return '';
  }

  deleteLineItem(id: string): Observable<any> {
    return this.gateway.delete('/quotes/maintenance/line-items/' + id);
  }

  loadquoteconfiguration(
    id: string,
    category: string,
  ): Observable<IQuoteItemPointsListConfiguration[]> {
    return this.gateway.get<IQuoteItemPointsListConfiguration[]>(
      `/quotes/${id}/items/configurations?c=${category}`,
    );
  }

  updateHotJob(hotjob: number, quote_id: string): Observable<IHotJobState> {
    return this.gateway.post<IHotJobState, IHotJobState>('/quotes/hot_jobs', {
      hot_job_state: hotjob,
      quote_id: quote_id,
    });
  }

  loadFilters() {
    return this.gateway.get('/quotes/filters');
  }

  load_quote_documents(
    quote_id: string,
  ): Observable<IQuoteDocumentsByCategory[]> {
    return this.gateway.get<IQuoteDocumentsByCategory[]>(
      '/quotes/' + quote_id + '/documents',
    );
  }

  load_quote_document(quote_id: string, doc_id: string): Observable<any> {
    return this.gateway.get<any>(`/quotes/${quote_id}/documents/${doc_id}`);
  }

  referenceExists(
    ref: string,
    exclude: string | null = null,
  ): Observable<UniqueRefResponse> {
    let params = new HttpParams();
    if (exclude) {
      params = params.set('exclude_id', exclude);
    }
    const url = `/quotes/reference/${ref}/unique`;
    return this.gateway.get<UniqueRefResponse>(url, '', { params: params });
  }

  downloadlink(quote_id: string): string {
    return `${this.gateway.endpoint}/quotes/${quote_id}/pointslists/download`;
  }

  download_sor_link(quote_id: string): string {
    return `${this.gateway.endpoint}/quotes/${quote_id}/sor/download`;
  }
}
